import { SET_STUDENT_INFO, SET_UNENROLLED_STUDENT_DOCUMENTS, ERROR_DOCUMENT_REQUEST, BEGINNING_REQUEST } from '../types'
import { handleExpiredAuthState } from './authActions'
import OwnEnrollmentDocumentsApi from '../../api/OwnEnrollmentDocumentsApi';
import AuthApi from '../../api/AuthApi';

const authApi = new AuthApi();
const enrollmentDocumentsApi = new OwnEnrollmentDocumentsApi();

/** get all information about a unenrolled student */
export const getUnenrolledStudentInfo = () => {
  return async (dispatch) => {

      dispatch(setLoading())

      try{

        const request = await Promise.all([
            authApi.studentInfo(),
            enrollmentDocumentsApi.list()
          ])

        const [studentInfo, documentsInfo] = request

        const payload = {
          info: studentInfo,
          documents: documentsInfo
        }

        dispatch(setUnenrolledStudentInformation(payload))

      } catch(error) {
        if (error?.response?.status === 401 ){
          dispatch(handleExpiredAuthState())
        } else {
          console.log(error.response)
        } 
      }
  }
}

export const getUnenrolledStudentDocuments = () => {
  return async (dispatch) => {

    dispatch({
      type: BEGINNING_REQUEST
    })

    try {
      const data = await enrollmentDocumentsApi.list();
      dispatch(setUnenrolledStudentDocuments(data))
    } catch(error){
      dispatch({
        type: ERROR_DOCUMENT_REQUEST
      })
    }
  }
}

const setUnenrolledStudentInformation = (payload) => ({
    type: SET_STUDENT_INFO,
    payload
  })

const setUnenrolledStudentDocuments = (payload) => ({
  type: SET_UNENROLLED_STUDENT_DOCUMENTS,
  payload
})

const setLoading = () => ({ type: BEGINNING_REQUEST })